exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-box {\n  position: absolute;\n  left: 1.328125rem;\n  right: 0;\n  top: 0.364583rem;\n  bottom: 0;\n  padding-bottom: 46PX;\n  -webkit-transition: left .3s ease-in-out;\n  transition: left .3s ease-in-out;\n  background: #eff1f5;\n}\n.content-collapse {\n  left: 0.4375rem;\n}\n.collapse-btn {\n  float: left;\n  padding: 0 0.130208rem;\n  font-size: 0.114583rem;\n  cursor: pointer;\n  line-height: 0.364583rem;\n  background-color: #00338d;\n  width: 0.4375rem;\n  text-align: center;\n}\n.collapse-icon-cls {\n  width: 0.114583rem;\n}", ""]);

// exports
